import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { updatePageSeo } from '../utils/seo';

const SeoManager = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const currentLanguage = i18n.language as 'en' | 'lt';
    updatePageSeo(currentLanguage);
  }, [i18n.language]);

  return null;
};

export default SeoManager;
